/* tslint:disable */ /* eslint-disable */
import * as Types from '../../../models/generated/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ExportPowerPointQueryVariables = Types.Exact<{
  scheduledSurveyId: Types.Scalars['Int'];
  attributeValueIds: Array<Types.Scalars['Int']> | Types.Scalars['Int'];
  userGroupUuids: Array<Types.Scalars['String']> | Types.Scalars['String'];
}>;


export type ExportPowerPointQuery = { exportScheduledSurveyAsPowerpoint: boolean };


export const ExportPowerPointDocument = gql`
    query ExportPowerPoint($scheduledSurveyId: Int!, $attributeValueIds: [Int!]!, $userGroupUuids: [String!]!) {
  exportScheduledSurveyAsPowerpoint(scheduledSurveyId: $scheduledSurveyId, attributeValueIds: $attributeValueIds, userGroupUuids: $userGroupUuids)
}
    `;

/**
 * __useExportPowerPointQuery__
 *
 * To run a query within a React component, call `useExportPowerPointQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportPowerPointQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportPowerPointQuery({
 *   variables: {
 *      scheduledSurveyId: // value for 'scheduledSurveyId'
 *      attributeValueIds: // value for 'attributeValueIds'
 *      userGroupUuids: // value for 'userGroupUuids'
 *   },
 * });
 */
export function useExportPowerPointQuery(baseOptions: Apollo.QueryHookOptions<ExportPowerPointQuery, ExportPowerPointQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportPowerPointQuery, ExportPowerPointQueryVariables>(ExportPowerPointDocument, options);
      }
export function useExportPowerPointLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportPowerPointQuery, ExportPowerPointQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportPowerPointQuery, ExportPowerPointQueryVariables>(ExportPowerPointDocument, options);
        }
export type ExportPowerPointQueryHookResult = ReturnType<typeof useExportPowerPointQuery>;
export type ExportPowerPointLazyQueryHookResult = ReturnType<typeof useExportPowerPointLazyQuery>;
export type ExportPowerPointQueryResult = Apollo.QueryResult<ExportPowerPointQuery, ExportPowerPointQueryVariables>;
